import { dew as _abisDew } from "../../constants/abis.js";
import { dew as _contractsDew } from "../../constants/contracts.js";
import { dew as _contractDew } from "../../errors/contract.js";
import { dew as _isBytesEqualDew } from "../../utils/data/isBytesEqual.js";
import { dew as _getActionDew } from "../../utils/getAction.js";
import { dew as _indexDew } from "../../utils/index.js";
import { dew as _callDew } from "./call.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.verifyHash = void 0;
  const abis_js_1 = _abisDew();
  const contracts_js_1 = _contractsDew();
  const contract_js_1 = _contractDew();
  const isBytesEqual_js_1 = _isBytesEqualDew();
  const getAction_js_1 = _getActionDew();
  const index_js_1 = _indexDew();
  const call_js_1 = _callDew();
  async function verifyHash(client, {
    address,
    hash,
    signature,
    ...callRequest
  }) {
    const signatureHex = (0, index_js_1.isHex)(signature) ? signature : (0, index_js_1.toHex)(signature);
    try {
      const {
        data
      } = await (0, getAction_js_1.getAction)(client, call_js_1.call, "call")({
        data: (0, index_js_1.encodeDeployData)({
          abi: abis_js_1.universalSignatureValidatorAbi,
          args: [address, hash, signatureHex],
          bytecode: contracts_js_1.universalSignatureValidatorByteCode
        }),
        ...callRequest
      });
      return (0, isBytesEqual_js_1.isBytesEqual)(data ?? "0x0", "0x1");
    } catch (error) {
      if (error instanceof contract_js_1.CallExecutionError) {
        return false;
      }
      throw error;
    }
  }
  exports.verifyHash = verifyHash;
  //# sourceMappingURL=verifyHash.js.map
  return exports;
}